import styled from 'styled-components';

export const StyledDiv = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
